import { useState, useEffect } from 'react';

export const useScrollPosition = (threshold = 20) => {
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const position = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
            
            if (position > threshold) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };
        window.addEventListener('scroll', handleScroll, true);

        handleScroll();

        return () => {
            window.removeEventListener('scroll', handleScroll, true);
        };
    }, [threshold]);

    return {
        isScrolled
    };
};